// External libraries
import gql from 'graphql-tag';

export const SHIPPING_METHODS_FRAGMENT = gql`
  fragment ShippingMethods on Cart {
    shippingMethods {
      id
      type
      label
      selected
      amount {
        currencyCode
        currencyFormatSymbolISOCurrency
        currencyValue
      }
    }
  }
`;
